import(/* webpackMode: "eager", webpackExports: ["Flex","Spin"] */ "__barrel_optimize__?names=Flex,Spin!=!/home/tenutaricco/public_html/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/home/tenutaricco/public_html/node_modules/@ant-design/icons/es/components/AntdIcon.js");
